<template>
    <div>
        <div class="container">
            <physician-profile :provider-entity-id="providerEntityId">
            </physician-profile>
            <div class="row">
                <div class="col-md-12">
                    <physician-plans :provider-entity-id="providerEntityId" :company-id="companyId" :token="token">
                    </physician-plans>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PhysicianProfile from "../../../components/shared/physicianProfileAndPlans/PhysicianProfile.vue";
    import PhysicianPlans from "./PhysicianPlans.vue";

    export default {
        name: "PhysicianProfilePresenter",
        components: {PhysicianPlans, PhysicianProfile},
        props: {
            companyId: {type: [Number], required: true},
            token: {type: [String], required: true},
            providerEntityId: {
                type: [Number], required: true
            }
        }
    }
</script>

<style scoped>

</style>